import type { Router } from "vue-router";

// Holds the router instance once it is created. Provides a dependency-free
// import point so that urlParams.ts (and similar sync utilities) can access
// the router without pulling router.ts into their static import chain, which
// would create a routes.ts → linkFactories → urlParams → router.ts → routes.ts
// circular dependency and a TDZ error in Nuxt's ESM evaluation order.
export let routerRef: Router | undefined;

export function setRouterRef(router: Router): void {
  routerRef = router;
}
